import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export type NotificationBallSeverity = 'success' | 'warning' | 'danger' | 'info';

@Component({
  selector: 'osp-notification-severity-ball',
  standalone: true,
  imports: [NgClass],
  templateUrl: './notification-severity-ball.component.html',
  styleUrls: ['./notification-severity-ball.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationSeverityBallComponent {
  $severity = input<NotificationBallSeverity>('info', { alias: 'severity' });
}
